/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import { ROUTER } from '../../constants/router';
import DataFlowService from '../../services/DataFlow.service';
import UserService from '../../services/UserService';
import ActivityProcess from './components/DataflowDetail/ActivityProcess';
import Detail from './components/DataflowDetail/Detail';
import TabsDetail from './components/DataflowDetail/Tabs';
import { STATUS_ID } from './STATUS_ID';
import AddOwner from './components/AddOwner';
import Comment from './components/Comment';
import DisplayDPIA from './components/DisplayDPIA';
import useQuery from '../../util/useQuery';
import usePermission from '../../hooks/usePermission';

export default function DataFlowDetail() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { businessProcessId } = useParams();

    const [detail, setDetail] = useState();
    const [databaseDetail, setDatabaseDetail] = useState();
    const [dataFlowInfo, setDataFlowInfo] = useState();
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dpiaOwner, setDpiaOwner] = useState([]);

    const getDataFlowDetail = async (businessProcessId) => {
        try {
            const { data } = await DataFlowService.getDataFlowDetail(
                businessProcessId
            );
            if (data?.resultData) {
                setDetail(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getDpia = async () => {
        try {
            const { data } = await DataFlowService.getDpiaDataFlowInfo(
                businessProcessId
            );
            if (data?.resultData) {
                setDpiaOwner(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getInventoryDataFlowInfo = async (businessProcessId) => {
        try {
            const { data } = await DataFlowService.getInventoryDataFlowInfo(
                businessProcessId
            );
            if (data?.resultData) {
                setDataFlowInfo(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getDataBaseDetail = async () => {
        setLoading(true);
        try {
            const { data } = await DataFlowService.getDataBaseDetail(
                businessProcessId
            );
            if (data?.resultData) {
                if (data.resultData.isSamePeriod == null) {
                    data.resultData.isSamePeriod = false;
                }
                setDatabaseDetail(data?.resultData);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getDataFlowDetail(businessProcessId);
        getDataBaseDetail();
        getInventoryDataFlowInfo(businessProcessId);
        getDpia();
    }, [businessProcessId]);

    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isAuditor } = usePermission();

    useEffect(() => {
        if (isAuditor) {
            navigate(
                ROUTER.DS_INVENTORY.DATAFLOW + '/' + businessProcessId + '/view'
            );
        }
    }, [isAuditor]);

    useEffect(() => {
        if (dataFlowInfo) {
            if (admin) {
                if (dataFlowInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW) {
                    //Waiting for Review
                    setEditMode(true);
                } else {
                    setEditMode(false);
                }
            } else {
                //Waiting for Review and Reviewed
                if (
                    dataFlowInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                    dataFlowInfo.statusId === STATUS_ID.REVIEWED
                ) {
                    setEditMode(false);
                } else {
                    setEditMode(true);
                }
            }
        }
    }, [dataFlowInfo]);

    const isRequestRevise = Number(dataFlowInfo?.isRequestRevise) === 1;

    return (
        <div>
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(ROUTER.DS_INVENTORY.DATAFLOW);
                    }}
                >
                    <IconBack />
                </button>
                {t('Data Flow Details')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} / {t('Data Flow')} /{' '}
                </span>
                <span>{t('Data Flow Details')}</span>
            </div>
            <div className="mt-6">
                <Detail
                    dataFlowInfo={dataFlowInfo}
                    detailDataflow={detail}
                    getInventoryDataFlowInfo={() =>
                        getInventoryDataFlowInfo(businessProcessId)
                    }
                />
                <div className="grid grid-cols-3 gap-4">
                    <TabsDetail
                        dataFlowInfo={dataFlowInfo}
                        loading={loading}
                        detail={detail}
                        getDataFlowDetail={getDataFlowDetail}
                        databaseDetail={databaseDetail}
                        getDataBaseDetail={() => getDataBaseDetail()}
                        editMode={editMode}
                        setEditMode={setEditMode}
                    />
                    <div className="space-y-3">
                        <div
                            hidden={dataFlowInfo?.statusId !== STATUS_ID.REVISE}
                            className="bg-[#FFECF0] p-4 mt-4 rounded-xl"
                        >
                            <div className="text-[#F0536F] font-semibold text-sm">
                                {t('RR.ReasonForRevise')}
                            </div>
                            <div className="my-4 border-2 border-solid border-[#FFCFD8]"></div>
                            <div>{dataFlowInfo?.reason}</div>
                        </div>
                        {dataFlowInfo?.reviseReason && isRequestRevise && (
                            <div className="bg-[#FFECF0] p-4 mt-4 rounded-xl">
                                <div className="text-[#F0536F] font-semibold text-sm space-x-2">
                                    <span>
                                        {t('Reason for request revised')}
                                    </span>
                                    <span className="text-purple-PHX">
                                        (
                                        <svg
                                            width="8"
                                            height="8"
                                            viewBox="0 0 8 8"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="4"
                                                cy="4"
                                                r="4"
                                                fill="#7B67FB"
                                            />
                                        </svg>{' '}
                                        {t(
                                            'Waiting for approval of request revised'
                                        )}
                                        )
                                    </span>
                                </div>
                                <div className="my-4 border-2 border-solid border-[#FFCFD8]"></div>
                                <div>{dataFlowInfo?.reviseReason}</div>
                            </div>
                        )}
                        <ActivityProcess
                            businessProcessId={businessProcessId}
                            dataFlowInfo={dataFlowInfo}
                        />
                        <AddOwner dataFlowInfo={dataFlowInfo} />
                        {dataFlowInfo?.comment && (
                            <Comment comment={dataFlowInfo?.comment} />
                        )}
                        <DisplayDPIA dpiaOwner={dpiaOwner} />
                    </div>
                </div>
            </div>
        </div>
    );
}
